/* eslint-disable complexity */
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Typography, Icon, Container } from '../';
import * as S from './styles';
import SvgRing from './SvgRing';
export var CircleProgress = forwardRef(function CircleProgress(props, ref) {
    var onClick = props.onClick, percentage = props.percentage, showCompleted = props.showCompleted, completed = props.completed, completedOf = props.completedOf, icon = props.icon, text = props.text, children = props.children, className = props.className, style = props.style, color = props.color, size = props.size;
    var colorClassName = color + "-color";
    var sizeClassName = size + "-size";
    var clickableClassName = onClick ? 'is-clickable' : false;
    var rootClass = cx(clickableClassName, colorClassName, sizeClassName, className);
    var onClickHandler = function (event) {
        if (onClick)
            onClick(event);
    };
    var finalPercentage = 0;
    if (percentage)
        finalPercentage = percentage;
    else if (completed && completedOf) {
        finalPercentage = (completed / completedOf) * 100;
    }
    var iconSize = 'medium';
    if (size === 'large')
        iconSize = 'xlarge';
    else if (size === 'medium')
        iconSize = 'large';
    else if (size === 'small')
        iconSize = 'medium';
    else if (size === 'xsmall')
        iconSize = 12;
    var textSize = size === 'large' || size === 'medium' ? 'medium' : 'small';
    return (React.createElement(S.CircleProgress, { flex: true, inline: true, direction: 'column', justifyContent: 'center', className: rootClass, style: style, onClick: onClickHandler, ref: ref },
        React.createElement(SvgRing, { size: size, percentage: finalPercentage, color: color }),
        showCompleted && (React.createElement(Typography, { className: 'completed-label', size: size === 'large' || size === 'medium' ? 'medium' : 'small', color: 'extra-light' }, percentage ? percentage + "%" : completed + "/" + completedOf)),
        icon && React.createElement(Icon, { name: icon, size: iconSize }),
        text && (React.createElement(Container, { top: icon ? 'small' : undefined },
            React.createElement(Typography, { weight: 'medium', align: 'center', size: textSize, style: { lineHeight: 1 } }, text))),
        children));
});
CircleProgress.defaultProps = {
    color: 'blue',
    size: 'medium'
};
CircleProgress.displayName = 'CircleProgress';
export default CircleProgress;
//# sourceMappingURL=CircleProgress.js.map